import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import QuoteForm from '../../../components/base/QuoteForm';
import { Link } from 'react-router-dom';

const FrenchDrainsPage = () => {
  return (
    <div className="min-h-screen">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-12 sm:pb-16 lg:pb-20 bg-gradient-to-br from-teal-50 via-orange-50 to-amber-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div>
              <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
                Expert <strong>French Drain Installation</strong> in <strong>Northwest Arkansas</strong>
              </h1>
              <p className="text-base sm:text-lg lg:text-xl text-gray-600 mb-6 sm:mb-8 leading-relaxed">
                Solve your drainage problems with professional <strong>French drain systems</strong> in <strong>Fayetteville, Rogers, Bentonville, and Springdale</strong>. Protect your foundation and eliminate standing water.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                <a href="tel:479-337-7565" className="inline-flex items-center justify-center bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 sm:px-8 py-4 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all active:scale-95 touch-manipulation shadow-lg whitespace-nowrap min-h-[56px]">
                  <i className="ri-phone-line mr-2 text-xl"></i> Call (479) 337-7565
                </a>
                <a href="/contact" className="inline-flex items-center justify-center bg-white text-teal-600 border-2 border-teal-600 px-6 sm:px-8 py-4 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-teal-50 transition-all active:scale-95 touch-manipulation whitespace-nowrap min-h-[56px]">
                  Get Free Estimate
                </a>
              </div>
            </div>
            <div className="hidden lg:block">
              <img 
                src="https://public.readdy.ai/ai/img_res/20e140b93423611fa7c146dabdcd238b.jpg"
                alt="French drain installation"
                className="w-full h-auto rounded-lg shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* What is a French Drain */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-8 sm:mb-12">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
                What is a <strong>French Drain</strong>?
              </h2>
            </div>
            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg p-6 sm:p-8 lg:p-10 shadow-md">
              <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed">
                A <strong>French drain</strong> is a highly effective drainage solution that redirects water away from your home's foundation. It consists of a trench filled with gravel and a perforated pipe that collects and channels water to a safe drainage area.
              </p>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
                This proven system prevents water accumulation, foundation damage, basement flooding, and landscape erosion—common problems in <strong>Northwest Arkansas</strong> due to our heavy rainfall and clay-rich soil.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-amber-50 to-orange-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              Benefits of <strong>French Drains</strong>
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-t-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-home-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Foundation Protection</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Prevent water from pooling around your foundation, which can cause cracks, settling, and structural damage.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-t-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-water-flash-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Prevent Flooding</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Eliminate standing water in your yard and prevent basement or crawl space flooding during heavy rains.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-t-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-plant-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Landscape Protection</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Prevent soil erosion and protect your landscaping, gardens, and lawn from water damage.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-t-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-money-dollar-circle-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Increase Property Value</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Proper drainage is a valuable feature that protects your investment and appeals to future buyers.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-t-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-bug-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Pest Prevention</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Eliminate standing water that attracts mosquitoes and other pests to your property.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-t-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-time-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Long-Lasting Solution</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Properly installed French drains provide decades of reliable drainage with minimal maintenance.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Installation Process */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              Our <strong>French Drain Installation</strong> Process
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            <div className="text-center">
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold shadow-lg">
                1
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Site Assessment</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                We evaluate your property's drainage issues, soil type, and water flow patterns to design the optimal solution.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold shadow-lg">
                2
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Trench Excavation</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                We carefully dig trenches at the proper depth and slope to ensure effective water flow away from your home.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold shadow-lg">
                3
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>System Installation</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                We install landscape fabric, gravel, and perforated pipe, then cover with additional gravel for optimal drainage.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold shadow-lg">
                4
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Final Restoration</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                We restore your landscape, test the system, and ensure your property looks great with proper drainage.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-teal-600 via-teal-700 to-cyan-800 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6">
              Solve Your Drainage Problems Today
            </h2>
            <p className="text-base sm:text-lg lg:text-xl mb-6 sm:mb-8 text-teal-50">
              Contact <strong>NWA Gutter Guards</strong> for expert <strong>French drain installation</strong> in <strong>Northwest Arkansas</strong>. Free site evaluation and estimates.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
              <a href="tel:479-337-7565" className="inline-flex items-center justify-center bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 sm:px-8 py-3.5 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all active:scale-95 touch-manipulation shadow-lg whitespace-nowrap min-h-[56px]">
                <i className="ri-phone-line mr-2"></i> Call (479) 337-7565
              </a>
              <a href="/contact" className="inline-flex items-center justify-center bg-white text-teal-600 px-6 sm:px-8 py-3.5 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-teal-50 transition-all active:scale-95 touch-manipulation whitespace-nowrap min-h-[56px]">
                Get Free Estimate
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Quote Form */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto">
            <QuoteForm 
              title="Get Your Free Drainage Consultation"
              subtitle="Custom solutions for french drains, downspouts, and tree protection"
            />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FrenchDrainsPage;